import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const Logout18 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={18}
    contrast={contrast}
    className={className}
  >
    <g clipPath='url(#clip0_1_627)'>
      <path
        d='M8.2678 0.691786L5.71875 3.25072L6.78149 4.30929L9.1804 1.90094L16.2795 9.00001L9.1804 16.0991L6.78149 13.6907L5.71875 14.7493L8.25867 17.2994L8.2678 17.3082C8.7691 17.7947 9.59118 17.7948 10.0925 17.3083L17.4759 9.92486C17.9895 9.42547 17.9895 8.57459 17.476 8.07518L10.1005 0.699616L10.0924 0.691786C9.5911 0.205256 8.76914 0.205257 8.2678 0.691786Z'
        fill='currentColor'
      />
      <path
        d='M3.71978 5.46967L4.78044 6.53033L3.06077 8.25001H11.14V9.75001H3.06078L4.78044 11.4697L3.71978 12.5303L0.189453 9L3.71978 5.46967Z'
        fill='currentColor'
      />
    </g>
    <defs>
      <clipPath id='clip0_1_627'>
        <rect width='18' height='18' fill='white' />
      </clipPath>
    </defs>
  </Svg>
);

Logout18.displayName = 'Logout18';
export default Logout18;
